export default __webpack_public_path__ + "static/media/Asta Hole.faf2fd0d.png";